import { api } from "@/lib/api";

import type {
  CreateEmailConnectionReq,
  EmailConnection,
  UpdateEmailConnectionReq,
} from "@artisancode/api-types";

export const emailConnectionService = {
  list: () => api.get<EmailConnection[]>("/email-connections"),
  create: (data: CreateEmailConnectionReq) =>
    api.post<EmailConnection>("/email-connections", data),
  update: (id: string, data: UpdateEmailConnectionReq) =>
    api.put<EmailConnection>(`/email-connections/${id}`, data),
  remove: (id: string) => api.del<null>(`/email-connections/${id}`),
  setPrimary: (id: string) =>
    api.post<EmailConnection>(`/email-connections/${id}/primary`, {}),
};
